import React, { memo, useState, useRef } from "react";
import {
  Text,
  StyleSheet,
  View,
  TouchableOpacity,
  Pressable,
} from "react-native";
import color from "@constants/color";
import { Menu, MenuItem } from "react-native-material-menu";
import Upi from "@assets/svg/WithdrawGullakMoney/Upi";
import Bank from "@assets/svg/WithdrawGullakMoney/Bank";
import FastestTag from "@assets/svg/WithdrawGullakMoney/FastestTag";

import SettingBlack from "@assets/svg/SettingBlack";
import { getWalletOtp, setPrimaryFundAccount } from "@services/api";
import { useDispatch } from "react-redux";
import { actions as walletActions } from "@reducers/oldWalletReducer";
import t from "@constants/localization";
import DeletePaymentModeModal from "./DeletePaymentModeModal";
import { DeleteBankAc } from "@constants/strings";

const WithdrawTransitionCard = ({ navigation, type, listData }) => {
  const PATH = "screens/WithDrawGullakMoney/transitionCard";
  const dispatch = useDispatch();
  const [menuStates, setMenuStates] = useState(
    Array(listData.length).fill(false),
  );
  const [modalVisible, setModalVisible] = useState(false);
  const setSelectedIndexRef = useRef(null);

  const handleMenuPress = (index) => {
    const updatedMenuStates = [...menuStates];
    updatedMenuStates[index] = !updatedMenuStates[index];
    setMenuStates(updatedMenuStates);
  };

  const handleMenuItemPress = (index, action) => {
    const updatedMenuStates = [...menuStates];
    updatedMenuStates[index] = false;
    setMenuStates(updatedMenuStates);
    if (action === "Primary") {
      setPrimaryAccount(listData[index]);
    } else if (action === "Remove") {
      setModalVisible(true);
      setSelectedIndexRef.current = index;
    }
  };
  const handleModalClose = (clicked, number) => {
    if (clicked === DeleteBankAc.Cancel) {
      setModalVisible(false);
    } else {
      setModalVisible(false);
      removeAccount(listData[number]);
    }
  };

  const setPrimaryAccount = async (item) => {
    const { id } = item;
    try {
      const res = await setPrimaryFundAccount({
        fund_account_id: id,
      });
      if (res.status === 412) {
        navigation.navigate("VerifyAccount", {
          type: "set_primary",
          item,
        });
      }
      dispatch(walletActions.fetchFundAccounts());
    } catch (error) {
      console.log(error);
    }
  };

  const removeAccount = async (item) => {
    const { account_number, upi_address } = item;
    const otpPayload = {};
    if (account_number) otpPayload.account_number = account_number;
    if (upi_address) otpPayload.upi_address = upi_address;
    try {
      const res = await getWalletOtp({
        type: "delete",
        isDebug: __DEV__,
        ...otpPayload,
      });
      navigation.navigate("VerifyAccount", {
        type: "delete",
        item,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const renderListItems = (item, index) => (
    <>
      <TouchableOpacity
        testID="wgm-list-item"
        style={styles.listCard}
        key={index}
        activeOpacity={0.8}
        onPress={() => {
          navigation.navigate("WithdrawFromAcc", { item });
        }}
      >
        {item.is_default ? (
          <View style={styles.tagContainer}>
            <Text style={styles.tagText}>{t(`${PATH}/primary`)}</Text>
          </View>
        ) : null}
        <View style={{ flexDirection: "column" }}>
          <Text style={styles.bankText}>{item.user_name}</Text>
          {type === "bank_account" ? (
            <Text style={styles.bankSubText}>A/C : {item.account_number}</Text>
          ) : (
            <Text style={styles.bankSubText}> {item.upi_address}</Text>
          )}
        </View>
        <Menu
          visible={menuStates[index]}
          anchor={
            <Pressable
              testID="wgm-menu-btn"
              onPress={() => handleMenuPress(index)}
              style={styles.menuIconContainer}
            >
              <SettingBlack />
            </Pressable>
          }
          onRequestClose={() => handleMenuItemPress(index, "close")}
        >
          <MenuItem onPress={() => handleMenuItemPress(index, "Remove")}>
            {type === "bank_account"
              ? t(`${PATH}/removeBank`)
              : t(`${PATH}/removeUPI`)}
          </MenuItem>
        </Menu>
      </TouchableOpacity>
      {modalVisible && setSelectedIndexRef.current === index ? (
        <DeletePaymentModeModal
          visible={modalVisible}
          type={type}
          PATH={PATH}
          onPress={handleModalClose}
          number={setSelectedIndexRef.current}
          accountText={
            type === "bank_account" ? item.account_number : item.upi_address
          }
        />
      ) : null}
    </>
  );

  return (
    <View style={styles.modeContainer}>
      <View style={styles.rowContainer}>
        <View style={{ flexDirection: "row" }}>
          {type === "bank_account" ? <Bank /> : <Upi />}
          <Text style={styles.tabHeaderText}>
            {type === "bank_account"
              ? t(`${PATH}/bankTransfer`)
              : t(`${PATH}/upiID`)}
          </Text>
          {type === "vpa" ? <FastestTag /> : null}
        </View>
        <TouchableOpacity
          onPress={() => {
            navigation.navigate("GullakAddFund", { type });
          }}
          testID="wgm-add-btn"
        >
          <Text style={styles.addText}>{t(`${PATH}/add`)}</Text>
        </TouchableOpacity>
      </View>
      {listData &&
        listData.length > 0 &&
        listData.map((item, index) => renderListItems(item, index))}
    </View>
  );
};
export default memo(WithdrawTransitionCard);

const styles = StyleSheet.create({
  modeContainer: {
    backgroundColor: color.lightGrey,
    width: "90%",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    margin: 20,
    padding: 16,
    borderRadius: 16,
    borderColor: color.blank_grey,
    borderWidth: 1,
  },
  rowContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: 10,
  },
  tabHeaderText: {
    paddingHorizontal: 10,
    fontSize: 16,
    fontWeight: "700",
    color: color.black,
  },
  bankText: {
    fontSize: 16,
    fontWeight: "500",
  },
  bankSubText: {
    fontSize: 12,
    color: color.mediumBlacklightBlack,
  },
  addText: {
    fontSize: 16,
    fontWeight: "bold",
    color: color.primary,
    marginLeft: 10,
  },
  listCard: {
    width: "100%",
    backgroundColor: color.white,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 16,
    paddingVertical: 14,
    paddingHorizontal: 20,
    borderRadius: 10,
    elevation: 0.5,
  },
  menuIconContainer: {
    justifyContent: "center",
    height: 30,
    width: 35,
    alignItems: "flex-end",
  },
  tagContainer: {
    position: "absolute",
    top: -10,
    left: 10,
    backgroundColor: color.plain_green,
    padding: 2,
    borderRadius: 9,
  },
  tagText: {
    fontSize: 10,
    color: color.white,
    fontWeight: "700",
    paddingHorizontal: 8,
  },
});
